import axios from 'axios'

const http = axios.create({
  baseURL: '',
  timeout: 10000
})

export function apiGet(url, params) {
  return http.get(url, { params }).then(res => res.data.data)
}

export function apiPost(url, data) {
  return http.post(url, data).then(res => res.data)
}

export function asset(url) {
  if (!url) return ''
  if (url.indexOf('http') === 0 || url.indexOf('/uploads') === 0 || url.indexOf('/static') === 0) return url
  return url
}

/**
 * 获取封面图 URL：列表页优先用缩略图，缩略图不存在时回退原图
 */
export function coverUrl(item) {
  if (item.coverThumbUrl) return item.coverThumbUrl
  return item.coverUrl || ''
}

// ─── WebP 能力检测（canvas toDataURL 技巧） ───
let _webpChecked = false
let _webpOk = false

function checkWebP() {
  if (_webpChecked) return _webpOk
  _webpChecked = true
  try {
    const canvas = document.createElement('canvas')
    canvas.width = canvas.height = 1
    _webpOk = canvas.toDataURL('image/webp').startsWith('data:image/webp')
  } catch (e) {
    _webpOk = false
  }
  return _webpOk
}

/**
 * 将 banner / 静态图片 URL 自动转为 WebP（浏览器支持时）。
 * 仅对 /static/ 或 /uploads/ 路径下的 jpg/jpeg/png 生效。
 */
export function bannerAsset(url) {
  if (!url) return ''
  if (checkWebP() && /\.(jpg|jpeg|png)$/i.test(url)) {
    return url.replace(/\.(jpg|jpeg|png)$/i, '.webp')
  }
  return url
}

